"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var router_1 = require("@reach/router");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

exports.Link = function (props) {
  var Comp = props.to ? router_1.Link : "a";
  return React.createElement(Comp, __assign({
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "link", props.className])
  }, props));
};

exports.Link.displayName = "Link";